<div class="sticky-custom" style="min-height: 84px">
  <app-header [isPrivate]="true"></app-header>
</div>
<ng-container *ngIf="bannerVisible">
  <app-banner [visible]="bannerVisible" [content]="bannerContent"></app-banner>
</ng-container>

<div class="max-w-80 mx-auto py-5 px-3" style="min-height: 80vh">
  <app-breadcrumb class="hidden lg:flex"></app-breadcrumb>
  <router-outlet />
</div>
<app-footer></app-footer>
<div class="sticky-custom bottom">
  <app-fab></app-fab>
  @if(isMobile) {
  <app-mobile-nav></app-mobile-nav>
  }
</div>
<p-dialog
  header="{{ messageDialog.header }}"
  [draggable]="false"
  [modal]="true"
  [(visible)]="profileRedirectDialogVisible"
  [closable]="false"
  [style]="{ width: '25rem' }">
  <span class="p-text-secondary block my-3">
    {{ messageDialog.message }}
  </span>
  <p [innerHTML]="" class="text-sm">
    {{ messageDialog.description }}
  </p>
  <div class="flex justify-content-end gap-2">
    <p-button label="Ok" (click)="redirectToUserProfile()" />
  </div>
</p-dialog>
